module.exports = __webpack_public_path__ + "static/media/bg_3.f4fdc6aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/bg_3.svg
// module id = 235
// module chunks = 0